import { render, staticRenderFns } from "./PriceSnapshotFormDialog.vue?vue&type=template&id=016d2e7e&"
import script from "./PriceSnapshotFormDialog.vue?vue&type=script&lang=ts&"
export * from "./PriceSnapshotFormDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports